export const environment = {
  environment: 'development',
  // Keycloak
  keycloakUrl: 'https://auth.test123.nl',
  keycloakRealm: 'netwerk-levend-erfgoed',
  keycloakClientId: 'staging',
  // API
  apiUrl: 'https://nle-cms-api.test123.nl',
  // apiUrl: 'http://nle-cms-api.docker:8080'
};
